export default __webpack_public_path__ + "static/media/3 (2).82108abd.jpg";